// Claves que usan los componentes copiados de punto-world (frontend-shared).
// Mismos valores que `apps/janus/public/locales/es/translation.json`.
// Es el espacio de nombres por defecto porque esos componentes llaman a
// `useTranslation()` sin indicarlo.
export const shared = {
  DataTable: {
    collapse_row: "Contraer fila",
    error_description:
      "Por favor, intenta refrescar la página o contactar con soporte.",
    error_title: "Ha ocurrido un error",
    expand_row: "Expandir fila",
    page_literal: "Página {{pageFrom}} de {{pageTo}}",
    select_all: "Seleccionar todo",
    select_row: "Seleccionar",
  },
  Filters: {
    apply: "Aplicar",
    date_ranges: {
      currentMonth: "Este mes",
      currentWeek: "Esta semana",
      pastMonth: "Mes pasado",
      pastWeek: "Semana pasada",
      title: "Rangos de fecha",
    },
  },
  FormManager: {
    actions: {
      cancel: "Cancelar",
      delete: "Borrar",
      edit: "Editar",
      save: "Guardar",
    },
    delete: {
      confirm: "¿Estás seguro de que quieres borrar {{what}}?",
      description: "Esta acción no se puede deshacer.",
    },
    labels: {
      boolean: {
        false: "No",
        true: "Sí",
      },
    },
    messages: {
      deleted: "Información borrada correctamente",
      deleting: "Borrando información",
      error_deleting: "Error al borrar la información",
      error_saving: "Error al guardar la información",
      saved: "Información guardada correctamente",
      saving: "Guardando información",
      validation_error: "Hay errores de validación en el formulario",
    },
  },
  Generic: {
    and: "y",
    and_x_more: "y {{count}} más",
  },
};
